<template>
  <div class="about container">
    <div class="writeup">
      <div class="columns custom-columns">
              <div class="column is-4">
          <article class="tile box is-child notification is-orange">
            <img src="../../../static/photos/OOSH_003.jpg">
          </article>
      </div>
      <div class="column is-offset-1 is-7 is-12-touch">
    <h1 class='title'>About</h1>
    <p class="is-size-5 left">
OOSH Zone Australia provides reliable, child focused out of school hour’s care that is accessible to all families within the School community. We strive to maintain high quality standards of service in a welcoming, caring, friendly and stimulating environment.
    <br>
    <br>
At OOSH Zone we are committed to providing a fun, quality program that allows children to contribute to how their time will be spent whilst at OOSH. Structured and unstructured play activities provide opportunities for children to explore, experiment and engage with each other the wider community. We recognise the significance of children engaging in meaningful experiences to facilitate their learning and development. The structure of the OOSH Zone environment enables children to foster a sense of self-worth, nurture positive group relationships and encourage cooperative and collaborative behaviour.
    </p>
</div>
</div>
      <div class="columns ">
<div class="column has-text-left">
<p class="is-size-3">Before School Care</p>
<p class="is-size-5">
The Before School Care service is designed to offer a balance of quiet activities that builds the mind and body. If necessary an optional healthy breakfast is provided. Children are offered opportunities to participate in board games, creative play and yoga.
</p>
<p class="is-size-3">
After School Care
</p>
<p class="is-size-5">
The After School Care service is designed to offer a balance in activities that builds the mind and body. After being served a healthy afternoon snack, children can participate in team or individual sports, as well as a range of physical activities that develop fitness, coordination and teamwork.
<br><br>
Creative arts projects, music, dance and drama activities ensure children develop vital self esteem, and learn how to express themselves. A quiet time is provided for children to do homework if parents so wish.
</p>
<p class="is-size-3">Vacation Care and Pupil Free Days</p>
<p class="is-size-5">
Vacation Care is offered in school holiday periods. Special theme days provide a range of interesting activities to keep the children interested and engaged. Care is also available on staff development days.
</p>
<p class="is-size-3">Food and Nutrition</p>
<p class="is-size-5">
Nutritious snacks and afternoon tea based on the five food groups will be offered. Opportunities to discuss the nutritional value of the food groups will be provided. Children will be encouraged to self-serve and will be given opportunities to assist in food preparation where possible. Cold water will be available year round. Examples of foods served include: fresh fruit and vegetables, sandwiches, yoghurt, pita bread, raisin bread, dips, cheese, sultanas, picklets, soups etc. A selection of breakfast cereals low in sugar, salt and fat as well as fruit and toast will be available as an optional breakfast.
 </p>
</div>
      </div>
 </div>
<div class="school">
<div class="opening-times">
<p class='title'>Opening Times</p>
   <p class="subtitle">
    <span v-show="school === 'stjustins'">St Justin’s Catholic Primary School Center</span>
    <span v-show="school === 'stgregs'">St Gregory’s College Junior School Center</span>
    <span v-show="school === 'maryimmaculate'">Mary Immaculate Catholic Parish</span>
  </p>
<div v-show="school === 'stjustins'" class="columns" id="times">
  <div class="column">
  </div>
  <div class="column">
 <div class="is-outlined is-large is-dark"><strong>Before School Care</strong><br>6:30am - 8:30am</div>
  </div>
  <div class="column">
 <div class="is-outlined is-large is-dark"><strong>After School Care</strong><br>3:10pm - 6:30pm</div>
</div>
  <div class="column">
 <div class="is-outlined is-large is-dark"><strong>Vacation Care</strong><br>7:30am - 5:30pm</div>
</div>
  <div class="column">
  </div>
  </div>
  <div v-show="school === 'stgregs'" class="columns">
  <div class="column">
  </div>
  <div class="column">
 <div class=" is-outlined is-large is-dark"><strong>Before School Care</strong><br>6:30am - 8:00am</div>
  </div>
  <div class="column">
 <div class=" is-outlined is-large is-dark"><strong>After School Care</strong><br>3:00pm - 6:00pm</div>
</div>
  <div class="column">
 <div class=" is-outlined is-large is-dark"><strong>Pupil Free and Vacation</strong><br>7:30am - 5:30pm</div>
</div>
  <div class="column">
  </div>
  </div>
  <div v-show="school === 'maryimmaculate'" class="columns">
  <div class="column">
  </div>
  <div class="column">
 <div class=" is-outlined is-large is-dark"><strong>Before School Care</strong><br>6:30am - 8:30am</div>
  </div>
  <div class="column">
 <div class=" is-outlined is-large is-dark"><strong>After School Care</strong><br>2:30pm - 6:00pm</div>
</div>
  <div class="column">
 <div class=" is-outlined is-large is-dark"><strong>Pupil Free and Vacation</strong><br>7:30am - 5:30pm</div>
</div>
  <div class="column">
  </div>
  </div>
  </div>
</div>
    </div>
</template>

<script>
export default {
  name: 'About',
  props: ['school'],
  data () {
    return {
      msg: 'Welcome to the OOSH Zone!',
      stjustins: {
        name: 'St Justin’s Catholic Primary School',
        phone: '0425213083',
        times: {
          morning: '6:45am - 8:30am',
          afternoon: '3:30pm - 6:30pm',
          vacation: '7:30am - 5:30pm'
        }
      },
      stgregs: {
        name: 'St Gregory’s College Junior School',
        phone: '0467866256',
        times: {
          morning: '6:30am - 8:00am',
          afternoon: '3:30pm - 6:30pm',
          vacation: '6:30am - 6:30pm'
        }
      }
    }
  }
}
</script>

<style scoped>
.about {
  padding: 2em;
  padding-top: 60px;
}
.left {
  text-align: left;
}
.is-orange {
  padding: 20px;
  background: #2d3436;
  color: #e67e22;
}
.writeup .columns .column {
  margin: auto;
}
.school {
  margin: 80px auto 120px auto;
}
.is-size-5 {
  padding-bottom: 30px;
}
@media(max-width: 767px) { /* <== You can change this break point as per your  needs */
  .custom-columns {
    flex-direction: column-reverse;
    display: flex;
  }
}
.hide {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/About.vue